import { API_URL } from '../utils/api';

export class ApiError extends Error {
  status: number;
  payload: unknown;

  constructor(status: number, payload: unknown, message: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.payload = payload;
  }
}

export function errorMessage(error: unknown, fallback = 'Unbekannter Fehler'): string {
  if (error instanceof ApiError) {
    if (error.payload && typeof error.payload === 'object' && error.payload !== null && 'error' in error.payload) {
      const msg = (error.payload as { error?: unknown }).error;
      if (typeof msg === 'string' && msg.trim()) return msg;
    }
    return error.message || fallback;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}

type RequestOptions = {
  method?: string;
  body?: unknown;
  auth?: boolean;
  headers?: Record<string, string>;
  isFormData?: boolean;
};

export async function apiRequest<T>(path: string, options: RequestOptions = {}): Promise<T> {
  const { method = 'GET', body, auth = false, headers = {}, isFormData = false } = options;
  const reqHeaders: Record<string, string> = { ...headers };

  if (!isFormData && body !== undefined) {
    reqHeaders['Content-Type'] = 'application/json';
  }

  if (auth) {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('adminToken') : null;
    if (token) {
      reqHeaders.Authorization = `Bearer ${token}`;
    }
  }

  const response = await fetch(`${API_URL}${path}`, {
    method,
    headers: reqHeaders,
    body: body === undefined
      ? undefined
      : isFormData
        ? body as FormData
        : JSON.stringify(body),
  });

  let payload: unknown = null;
  if (typeof response.text === 'function') {
    const text = await response.text();
    if (text) {
      try {
        payload = JSON.parse(text);
      } catch {
        payload = text;
      }
    }
  } else if (typeof response.json === 'function') {
    payload = await response.json();
  }

  if (!response.ok) {
    const message =
      payload && typeof payload === 'object' && 'error' in payload
        ? String((payload as { error: unknown }).error)
        : `Fehler ${response.status}`;
    throw new ApiError(response.status, payload, message);
  }

  return payload as T;
}
